export default __webpack_public_path__ + "static/media/erika_stallings_070121_mixdown_0517-0605.16c9bc5d.wav";